import $axios from '@/axios-instance'
import { socketId } from './echo'

const baseUrl = '/api/v1/event'

// Attach the Echo/pusher socket id so Laravel's broadcast()->toOthers() excludes
// the originating client from the fan-out (the sender already updates optimistically).
const writeConfig = () => {
  const id = socketId()
  return id ? { headers: { 'X-Socket-ID': id } } : {}
}

export const realtimeApi = {
  async checkChannel(partnerId) {
    const { data } = await $axios.post(
      `${baseUrl}/channels/check`,
      { partner_id: partnerId },
      writeConfig(),
    )
    return data
  },
  async privateChannelParticipants() {
    const { data } = await $axios.get(`${baseUrl}/channels/private-participants`)
    return data.participants
  },
  // Global cross-room location map (proxied live from the Worker's presence state).
  async getLocations() {
    const { data } = await $axios.get(`${baseUrl}/locations`)
    return data.locations
  },
  // Por páginas: sin params, los últimos 50; { before: id } la página
  // anterior; { after: id } lo posterior (al reconectarse). Devuelve
  // { messages, has_more, has_more_after, is_participant }.
  async getChannelMessages(channelId, params = {}) {
    const { data } = await $axios.get(`${baseUrl}/channels/${channelId}/messages`, {
      params,
    })
    return data
  },
  async storeMessage(channelId, payload) {
    const { data } = await $axios.post(
      `${baseUrl}/channels/${channelId}/messages`,
      payload,
      writeConfig(),
    )
    return data.message
  },
  async deleteMessage(messageId) {
    await $axios.delete(`${baseUrl}/messages/${messageId}`, writeConfig())
  },
  async addChannelParticipant(channelId, userId = null) {
    const { data } = await $axios.post(
      `${baseUrl}/channels/${channelId}/participants`,
      userId ? { user_id: userId } : {},
      writeConfig(),
    )
    return data.participant
  },
  async signalUser(signalUser) {
    const { data } = await $axios.post(
      `${baseUrl}/call/signal`,
      signalUser,
      writeConfig(),
    )
    return data
  },
  async getThreadAnswers(threadId) {
    const { data } = await $axios.get(`${baseUrl}/threads/${threadId}/answers`)
    return data.thread
  },
  async storeQuestionAnswer(payload) {
    const { thread_id, ...body } = payload
    const { data } = await $axios.post(
      `${baseUrl}/threads/${thread_id}/answers`,
      body,
      writeConfig(),
    )
    return data.question_answer
  },
  async updateQuestionAnswer(payload) {
    const { id, ...body } = payload
    const { data } = await $axios.patch(
      `${baseUrl}/question-answers/${id}`,
      body,
      writeConfig(),
    )
    return data.question_answer
  },
  async deleteQuestionAnswer(id) {
    const { data } = await $axios.delete(
      `${baseUrl}/question-answers/${id}`,
      writeConfig(),
    )
    return data.thread
  },
}
